<script setup>
import XMark from '@dogfy/assets/icons/base/x-mark.svg?component'

const props = defineProps({
  theme: {
    type: String,
    default: null,
    validator: (value) => ['inverted', 'info'].includes(value),
  },
})
</script>

<template>
  <button class="app-button-x" :class="{ [`app-button-x--${props.theme}`]: !!props.theme }">
    <XMark />
  </button>
</template>

<style lang="scss">
.app-button-x {
  border: none;
  border-radius: $border-radius-circular;
  width: 24px;
  height: 24px;
  padding: 0;
  background-color: transparent;
  color: $color-neutral-darkest;

  @include breakpoint(lg) {
    width: 32px;
    height: 32px;
  }

  &:hover {
    cursor: pointer;
    color: $color-primary-darkest;
  }

  &--inverted {
    color: $color-neutral-white;

    &:hover {
      background-color: $color-neutral-semidark;
      color: $color-neutral-white;
    }
  }

  &--info {
    color: $color-feedback-info-dark;

    &:hover {
      background-color: $color-neutral-white;
      color: $color-feedback-info-dark;
    }
  }
}
</style>
